// extracted by mini-css-extract-plugin
export default {"tooltip":"xX-z","arrow":"yX-z"};